import { FormControl } from "@mui/material";
import SelectSysOutline from "../selectSysOutline";
import "./styles.css"

export default function MultiSelectGroup({ handleSelected, id, title, border, ...props }) {

  return (
    <>
      <p style={{ fontSize: '12px', marginBottom: '2px', color: '#2C4992', weight: '400', font: 'roboto' }}>{title}</p>
        <FormControl size="medium" sx={{ width: "100%" }}>
          <SelectSysOutline
            color="textBlue"
            {...props}
            multiple
            sx={{ width: "100%" }}
            onChange={(item, elemento) => {
              handleSelected(elemento);
            }}
            size="medium"
          />
        </FormControl>
    </>
  );
}
